<template>
  <router-view></router-view>
</template>

<script>
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap"  // This includes Popper.js, so no need for bootstrap.min.js
import "bootstrap-icons/font/bootstrap-icons.min.css"
export default {
  name: 'App',
  components: {
  }
}
</script>

<style>
* { box-sizing: border-box; }
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
}
</style>
